import React from 'react';

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableBody,
  TableRow,
  TableCell,
  Text,
  Amount,
  Box,
  Card,
  CardBody,
} from '@razorpay/blade/components';
import { AssignedFlexibleComponentsTableDataType } from '../../types';
import { YearlyAmountColumn } from './YearlyAmountColumn';
import { isFBPUnitAmount } from 'components/PayDetails/utils';

export const FlexibleAssignmentsView = ({
  assignments,
  totalDeclared,
  totalAllocated,
  totalUnallocated,
}: {
  assignments?: AssignedFlexibleComponentsTableDataType[];
  totalDeclared: number;
  totalAllocated: number;
  totalUnallocated: number;
}) => {
  return (
    <Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr" gap="spacing.4">
        <Card>
          <CardBody>
            <Text size="small" weight="regular" color="surface.text.gray.muted">
              Total Allocated amount
            </Text>
            <Amount testID="total-allocated" value={totalAllocated} />
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Text size="small" weight="regular" color="surface.text.gray.muted">
              FBP declaration
            </Text>
            <Amount testID="total-declared" value={totalDeclared} />
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Text size="small" weight="regular" color="surface.text.gray.muted">
              Unallocated amount
            </Text>
            <Amount testID="total-unallocated" value={totalUnallocated} />
          </CardBody>
        </Card>
      </Box>

      <Table
        data={{ nodes: assignments || [] }}
        display="grid"
        gridTemplateColumns="4fr 2fr 2fr 2fr"
        rowDensity="normal"
        marginTop={'spacing.7'}>
        {(tableData) => (
          <>
            <TableHeader>
              <TableHeaderRow>
                <TableHeaderCell>
                  <Text weight="semibold">Component</Text>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Text weight="semibold">Max amount</Text>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Text weight="semibold">Monthly declaration</Text>
                </TableHeaderCell>
                <TableHeaderCell textAlign="right">
                  <Text weight="semibold">Yearly amount</Text>
                </TableHeaderCell>
              </TableHeaderRow>
            </TableHeader>

            <TableBody>
              {tableData.map((rowData) => (
                <TableRow item={rowData} key={rowData.id}>
                  <TableCell>
                    <Text size="medium" weight="regular">
                      {rowData.display_name}
                    </Text>
                  </TableCell>
                  <TableCell>
                    <Text>
                      {isFBPUnitAmount(rowData.unit) ? (
                        <Amount value={Number(rowData.maxValuePerMonth)} />
                      ) : (
                        `${rowData.maxValuePerMonth}${rowData.monthlyDeclaration.suffix}`
                      )}
                    </Text>
                  </TableCell>
                  <TableCell>
                    <Text>
                      {isFBPUnitAmount(rowData.unit) ? (
                        <Amount value={Number(rowData.monthlyDeclaration.value)} />
                      ) : (
                        `${rowData.monthlyDeclaration.value}${rowData.monthlyDeclaration.suffix}`
                      )}
                    </Text>
                  </TableCell>
                  <TableCell textAlign="right">
                    <YearlyAmountColumn
                      rowData={rowData}
                      monthlyDeclarationValue={rowData.monthlyDeclaration.value}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </>
        )}
      </Table>
    </Box>
  );
};
